<template>
  <div class="pa-2 pa-sm-15 mt-16">
    <v-container fluid class="px-0 pb-sm-3 px-sm-3 pt-0">
      <v-row class="">
        <v-col class="pb-3 pl-md-3" cols="12" md="4">
          <StoreTitle />
        </v-col>

        <v-col class="pb-6 pb-md-3 pr-md-3" cols="12" md="8">
          <StoreRewards />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4" class="pb-3 pb-md-0 pl-md-2 pt-0 pt-md-3">
          <StoreDescription :rewardsTemplate="true" />
        </v-col>
        <v-col class="pb-6 pb-md-0 pr-md-3" cols="12" md="3">
          <StoreHours :rewardsTemplate="true" />
        </v-col>
        <v-col
          cols="12"
          md="5"
          class="pb-3 pb-md-0 pr-sm-3 pr-md-4 pt-md-3 py-0"
        >
          <div
            class="background-color-white full-height min-height pa-2 rounded-lg"
          >
            <!--
              GoogleMap can't be conditionally rendered
            -->
            <GoogleMap />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import GoogleMap from "@/components/GoogleMap.vue";
import StoreTitle from "@/components/About/StoreTitle.vue";
import StoreDescription from "@/components/About/StoreDescription.vue";
import StoreHours from "@/components/About/StoreHours.vue";
import StoreRewards from "@/components/About/StoreRewards.vue";
export default {
  name: "StoreInfoRewardsView",
  components: {
    GoogleMap,
    StoreTitle,
    StoreDescription,
    StoreHours,
    StoreRewards,
  },
};
</script>

<style scoped>
.min-height {
  min-height: 388px;
}
</style>
